import { Route, Routes as RoutesContainer } from "react-router";
import { Create, Edit, Weight } from "../index";

const Routes = () => {
  return (
    <RoutesContainer>
      <Route exact path='/weight' element={<Weight />} />
      <Route exact path='/weight/create' element={<Create />} />
      <Route exact path='/weight/edit/:id' element={<Edit />} />
    </RoutesContainer>
  );
};
export default Routes;
